module.exports = __webpack_public_path__ + "img/item-info-icon6.ee48267b.svg";